import React from 'react';
import { createRoot } from 'react-dom/client';
import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

import IndicationReducer from '../reducers/indication.js';
import Indication from '../modules/indication/indication.js';

export default function createStore(
  preloadedState = {},
  extraReducers = {},
  extraMiddleware = []
) {
  const rootReducer = combineReducers({
    IndicationReducer,
    ...extraReducers,
  });

  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefault) => getDefault({
      serializableCheck: {
        ignoredPaths: ['IndicationReducer.isLoading.check']
      }
    }).concat(extraMiddleware),
  });

  createRoot(document.getElementById('page-indication')).render(
    <Provider store={store}>
      <Indication />
    </Provider>
  );

  if (module?.hot) {
    module.hot.accept('../reducers/indication.js', async () => {
      const { default: newIndication } =
        await import('../reducers/indication.js');

      store.replaceReducer(
        combineReducers({ indication: newIndication, ...extraReducers })
      );
    });
  }

  return store;
}
